import { PetInterface } from '../../../types/pet';
import { getDisplayBreed, getFormattedCelebrationDate } from '../../../util/helpers';
import { MedicalLabels } from '../../pet-form/MedicalNew/MedicalLabels';

const PLACEHOLDER_TEXT = 'Not added yet';

type DetailsField = {
  label: string;
  value: string | number | null;
};

export const getDisplayAge = (ageInMonths?: number) => {
  const monthsInYear = 12;
  if (ageInMonths === 0 || !ageInMonths) {
    return PLACEHOLDER_TEXT;
  }

  const years = Math.floor(ageInMonths / monthsInYear);
  const months = ageInMonths % monthsInYear;
  return years === 0
    ? `${months} month${months > 1 ? 's' : ''}`
    : `${years} year${years > 1 ? 's' : ''} and ${months} month${months > 1 ? 's' : ''}`;
};

export const getPetFields = (petProfile: PetInterface) => {
  const healthFields = getHealthFields(petProfile);
  const basicFields = getBasicFields(petProfile);
  return [healthFields, basicFields];
};

const getHealthFields = (petProfile: PetInterface): DetailsField[] => {
  const fields = [];
  fields.push(
    {
      label: 'Weight',
      value: !petProfile.weightLbs ? PLACEHOLDER_TEXT : `${petProfile.weightLbs} lbs`,
    },
    {
      label: MedicalLabels.labelMedicalConditions,
      value: petProfile.medicalConditions.map((item) => item.name).join(', '),
    },
    {
      label: MedicalLabels.labelMedications,
      value: petProfile.medications.map((item) => item.name).join(', '),
    },
    {
      label: MedicalLabels.labelMedicationAllergies,
      value: petProfile.medicationAllergies.map((item) => item.name).join(', '),
    },
  );
  return fields;
};

const unknownDerivedGender = 'Unknown';

const getBasicFields = (petProfile: PetInterface): DetailsField[] => {
  const {
    petType: { name: petTypeName },
  } = petProfile;

  const fields = [];
  fields.push(
    {
      label: 'Age',
      value: getDisplayAge(petProfile.ageInMonths),
    },
    {
      label: 'Birthday',
      value: getFormattedCelebrationDate({
        celebrationDate: petProfile.birthday,
        formatTokens: 'MMMM dd, yyyy',
      }),
    },
    {
      label: 'Adoption Date',
      value: getFormattedCelebrationDate({
        celebrationDate: petProfile.adoptionDate,
        formatTokens: 'MMMM dd, yyyy',
      }),
    },
    {
      label: 'Sex',
      value:
        petProfile.derivedGender === unknownDerivedGender
          ? null
          : petProfile.derivedGender
          ? petProfile.derivedGender
          : null,
    },
  );
  if (!['Cat', 'Dog', 'Horse'].includes(petTypeName)) {
    fields.push({
      label: 'Species',
      value: petProfile.petBreedName,
    });
  } else {
    fields.push({
      label: 'Breed',
      value: getDisplayBreed(petProfile, true),
    });
  }
  if (['Horse'].includes(petTypeName)) {
    petProfile.ridingStyles &&
      petProfile.ridingStyles.length !== 0 &&
      fields.push({
        label: 'Riding Styles',
        value: petProfile.ridingStyles.map((item) => item.name).join(', '),
      });
    petProfile.primaryDisciplines &&
      petProfile.primaryDisciplines.length !== 0 &&
      fields.push({
        label: 'Primary Disciplines',
        value: petProfile.primaryDisciplines.map((item) => item.name).join(', '),
      });
  }
  return fields;
};
